

const state = {
  data: {}, // Object to store data by ID
  watchers: {}, // Object to store watchers by ID and key
}
const mutations= {
  // Mutation to add data with an ID
  addData(state, { id, payload }) {
    state.data[id] = { ...state.data[id], ...payload };
  },
  // Mutation to remove data by ID
  removeData(state, id) {
    delete state.data[id];
  },
}
const actions= {
  // Action to publish data with an ID
  publishFigureData({ commit }, { id, payload }) {
    commit('addData', { id, payload });
  },
  // Action to remove data by ID
  unpublishFigureData({ commit }, id) {
    commit('removeData', id);
  },
}
const getters= {
  // Getter to retrieve data by ID and key
  getFigureDataWithKey: (state) => (id, key) => state.data[id]?.[key],
  // Getter to retrieve all data
  getFigureData: (state) => () => state.data,
}

export default {
  state,
  mutations,
  actions,
  getters,
}
